import { render } from "./Checkbox.vue?vue&type=template&id=4c9a8d03&scoped=true&ts=true"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=4c9a8d03&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9a8d03"],['__file',"resources/js/components/ui/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c9a8d03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c9a8d03', __exports__)) {
    console.log('reload')
    api.reload('4c9a8d03', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=4c9a8d03&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4c9a8d03', render)
  })

}


export default __exports__